import { X } from 'lucide-react';

interface ImagePreviewModalProps {
  readonly imageUrl: string;
  readonly onClose: () => void;
}

export function ImagePreviewModal({
  imageUrl, onClose 
}: ImagePreviewModalProps) {
  const handleBackdropClick = () => {
    onClose();
  };

  const handleImageClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div
      className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
      onClick={handleBackdropClick}
    >
      <button
        type="button"
        onClick={onClose}
        className="absolute top-4 right-4 h-10 w-10 rounded-full bg-white/10 text-white flex items-center justify-center hover:bg-white/20"
      >
        <X className="h-6 w-6" />
      </button>
      <img
        src={imageUrl}
        alt="Preview"
        className="max-w-full max-h-[90vh] object-contain rounded-lg"
        onClick={handleImageClick}
      />
    </div>
  );
}
